(function() {
  angular
    .module('documentos', ['aol.service', 'login.service']);
})();
